import { useContext, useState, useEffect } from "react"
import { ThemeContext } from "../../App"

export const ScrollIndicatorComponent = () => {
    const [theme,setTheme] = useContext(ThemeContext);
    const [scroll,setScroll] = useState(0);

    const scrollFunction = () => {
        let winScroll = document.body.scrollTop || document.documentElement.scrollTop;
        var height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        const scrolled = (winScroll/height) * 100;
        return scrolled
    };

    window.onscroll = () => {setScroll(scrollFunction())}

    return (
        <>
        <div style = {{
            width: `100%`,
            height: '6px',
            backgroundColor: theme.secondary
        }}>  
            <div style={{
                height: '6px',
                backgroundColor: theme.font.regular, 
                width: `${scroll}%`
            }}/>
        </div>
        </>
    )
}